// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { AlertTokens } from './type';

const alertTokens: AlertTokens = {
  alertInfoBackgroundColor: 'Brand-1',
  alertInfoBorderColor: 'Brand-2',
  alertInfoFontColor: 'Brand-6',
  alertSuccessBackgroundColor: 'Success-1',
  alertSuccessBorderColor: 'Success-2',
  alertSuccessFontColor: 'Success-6',
  alertWarningBackgroundColor: 'Warning-1',
  alertWarningBorderColor: 'Warning-2',
  alertWarningFontColor: 'Warning-6',
  alertDangerBackgroundColor: 'Danger-1',
  alertDangerBorderColor: 'Danger-2',
  alertDangerFontColor: 'Danger-6',
  alertIconSize: 'Font-16',
  alertFontSize: 'Font-14',
  alertFontWeight: 'Weight-regular',
  alertFontColor: 'Neutral-text-5',
  alertPaddingX: 'Spacing-16',
  alertPaddingY: 'Spacing-8',
  alertBorderRadius: 'Radius-default',
  alertNearlyMargin: 'Spacing-8',
  alertTitleFontSize: 'Font-16',
  alertTitleFontWeight: 'Weight-medium',
  alertTitleMarginY: 'Spacing-4',
  alertTitleIconWidth: 'Font-16',
  alertTitleIconHeight: 'Size-12',
  alertCloseFontColor: 'Neutral-text-4',
  alertCloseHoverColor: 'Neutral-text-5',
  alertCloseSize: 'Size-8',
  alertMessageHoverColor: 'Neutral-fill-2',
};

export default alertTokens;
